import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import CheckIcon from '@mui/icons-material/Check';

import { COLOR_PROFILE_FIELD } from 'components/ImageViewer/constants';
import {
  COLOR_PROFILE_OPTIONS,
  resolveColorProfile,
} from 'components/ImageViewer/colorProfiles/colorProfiles';
import {
  currentUserPreferencesSelector,
  isStaffSelector,
  updatePreferences,
} from 'store/slices/userDetailsSlice';

// Staff-only config wheel that lets reviewers switch the slide's color
// profile (Original / GT450). Hidden entirely for non-staff, and
// doing nothing until a non-Original profile is actually chosen.
export const ColorProfileMenu = () => {
  const dispatch = useDispatch();
  const isStaff = useSelector(isStaffSelector);
  const preferences = useSelector(currentUserPreferencesSelector);
  const [anchorEl, setAnchorEl] = useState(null);

  if (!isStaff) {
    return null;
  }

  const selectedProfile = resolveColorProfile(preferences[COLOR_PROFILE_FIELD]);
  const isOpen = Boolean(anchorEl);

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);
  const handleSelect = (value) => {
    dispatch(updatePreferences({ [COLOR_PROFILE_FIELD]: value }));
    closeMenu();
  };

  return (
    <>
      <Tooltip title="Viewer Presets">
        <IconButton
          size="small"
          aria-label="Viewer Presets"
          aria-haspopup="true"
          aria-expanded={isOpen}
          onClick={openMenu}
        >
          <PaletteIcon />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={isOpen} onClose={closeMenu}>
        {COLOR_PROFILE_OPTIONS.map(({ value, label }) => (
          <MenuItem
            key={value}
            selected={value === selectedProfile}
            onClick={() => handleSelect(value)}
          >
            {label}
            {value === selectedProfile && (
              <CheckIcon fontSize="small" sx={{ ml: 1 }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
